exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".echarts[data-v-6048f291]{height:610px;width:auto}", ""]);

// exports
